import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import { scroller } from 'react-scroll';
import { BaseContainer, BaseTitle } from './styles';
import { SectionName, SmallButton } from '../common/styles';

const Container = styled(BaseContainer)`
  margin-top: ${props => (props.theme.isMobile ? '32px' : '52px')};
  margin-bottom: ${props => (props.theme.isMobile ? '32px' : '52px')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Intro = styled.div`
  position: relative;
  text-align: ${props => (props.theme.isMobile ? 'left' : 'center')};
`;

const IntroTitle = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
`;

const IconContainer = styled(BaseContainer)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 90vw;
    max-width: 1087px;
  `)};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

const Image = styled(Img)`
  max-width: ${props => (props.theme.isMobile ? '100%' : '456px')};
  object-fit: cover;
`;

const Title = styled(BaseTitle)`
  max-width: 100%;
`;

const Button = styled(SmallButton)`
  background-color: #374662;
  width: 194px;

  &:hover {
    background-color: #BDC8DB;
  }
`;

export default function Testimonial() {
  const { testimonialImages } = React.useContext(ThemeContext);

  const scrollToGetInTouchForm = () => scroller.scrollTo('get_in_touch', {
    duration: 1500,
    smooth: 'easeInOutQuint',
  });

  return (
    <Container id="testimonial">
      <Intro>
        <IntroTitle>What our partners say</IntroTitle>
        <Title>
          Real Results, Real Feedback
        </Title>
      </Intro>
      <IconContainer>
        {testimonialImages.map(image => <Image key={image} src={image} />)}
      </IconContainer>
      <Button onClick={scrollToGetInTouchForm}>Request Case Studies</Button>
    </Container>
  );
}
